import {Box} from "@mui/material";
import {Outlet} from "react-router";
import Header from "./components/header/Header";
import Footer from "./components/Footer";

const Layout = () => {
    return (
        <Box
            sx={{
                minHeight: "100dvh",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Header/>
            <Box sx={{flexGrow: 1, display: "flex", justifyContent: "center"}}>
                <Box sx={{maxWidth: 1000, width: "100%"}}>
                    <Outlet/>
                </Box>
            </Box>
            <Footer/>
        </Box>
    )
}

export default Layout;